import React, { useRef, useEffect } from 'react';

interface ImageProps {
  src: string;
  alt: string;
  dataHook?: string;
  className?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
}

export const Image: React.FC<ImageProps> = ({ src, alt, dataHook, onLoad, onLoadStart, className }) => {
  const imageRef = useRef<HTMLImageElement>();
  useEffect(() => {
    if (imageRef.current && !imageRef.current.complete && onLoadStart) {
      onLoadStart();
    }
  }, [onLoadStart, src]);

  return (
    <img
      src={src}
      alt={alt}
      data-hook={dataHook}
      // @ts-ignore
      loading="lazy"
      onLoad={() => onLoad && onLoad()}
      ref={imageRef}
      className={className}
    />
  );
};
